//APIS
export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
export const API_KEY = `ce490b8c-c528-4704-b46c-39a5b3838d49`;

//TIMERS
export const TIMEOUT_SEC = 10;
export const MODAL_CLOSE_SEC = 2.5;

//PAGINATION
export const RECIPES_PER_PAGE = 10;